<template>
  <div class="tx-modal">
    <MtxModal :showing="modal === 'upload'" width="600px" persistent>
      <div class="text-center">
        <h3><MtxSvg icon="icon-upload" /></h3>
        <p>Please wait while your content uploads to IPFS</p>
      </div>
    </MtxModal>
    <MtxModal :showing="modal === 'tx'" width="600px" :persistent="!canClose" @hide="closeTxModal">
      <div class="text-center">
        <template v-if="totalSteps > 1">
          step {{ currentStep }} of {{ totalSteps }}
        </template>

        <template v-if="message">
          <h4>{{ message.header }}</h4>
          <p>{{ message.body }}</p>
        </template>

        <template v-if="!receipt">
          <p>
            <small v-if="currentStep < totalSteps">
              NOTE: This is part of a multi-transaction process. Once confirmed with MetaMask, you
              must wait for this transaction to be mined.
            </small>
          </p>
          <p>
            Please confirm the transaction with MetaMask.
            <br />
            <small>We'll wait for you here...</small>
          </p>
        </template>

        <template v-else>
          <p>Transaction submitted, waiting for miners.</p>
          <p>
            <TxProgress :tx="receipt" @success="nextStep" />
          </p>
          <p>
            <a
              :href="`${etherscan_url}/tx/${receipt}`"
              target="_blank"
              class="inline-flex align-center"
            >
              Check transaction status on Etherscan&nbsp;
              <MtxSvg icon="icon-link" />
            </a>
          </p>
        </template>
      </div>
    </MtxModal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"
import exitGuard from "@/mixins/exitGuard"

export default {
  mixins: [exitGuard],

  data: () => ({
    etherscan_url: process.env.VUE_APP_ETHERSCAN_URL,
    modal: null,
    message: null,
    receipt: null,
    currentStep: null,
    totalSteps: null
  }),

  computed: {
    ...mapState(["transactions"]),

    canClose() {
      return this.currentStep === this.totalSteps && this.receipt
    },

    preventExit() {
      return this.modal === "tx" && !this.canClose
    }
  },

  created() {
    this.$web3.$on("tx", this.handleTx)
    this.$web3.$on("upload", this.handleUpload)
  },

  methods: {
    ...mapActions(["addPendingTx", "clearPlannedTx", "dequeuePlannedTx"]),

    closeTxModal() {
      if (this.canClose) {
        this.modal = null
      }
    },

    async handleTx() {
      this.modal = "tx"

      this.currentStep = 0
      this.totalSteps = this.transactions.planned.length

      this.nextTx()
    },

    nextStep() {
      setTimeout(this.nextTx, 1000)
    },

    async nextTx() {
      if (this.currentStep === this.totalSteps) {
        this.modal = null
        return
      }

      const { tx, header, body } = await this.dequeuePlannedTx()

      this.currentStep++
      this.receipt = null
      this.message = { header, body }

      try {
        const receipt = await tx.send()
        this.receipt = receipt.hash

        this.addPendingTx({
          title: header,
          hash: receipt.hash
        })
      } catch (error) {
        this.modal = null
        this.clearPlannedTx()
        this.$emit("error", error)
      }
    },

    async handleUpload(upload, cb) {
      this.modal = "upload"

      try {
        let res = await upload

        // Run the callback if we have one
        cb && cb(false, res)
      } catch (error) {
        this.$emit("error", error)
        cb && cb(error)
      } finally {
        this.modal = null
      }
    }
  }
}
</script>
